import React, { useEffect, useState } from "react";
import { TableDisplay } from "../../../BP2Components/Table/TableDisplay";
import { Spin } from "../../../BP2Components";
import { useFormV3 } from "../../../../context/FormV3Context/FormV3Context";

import "../formsV3.less";

const FormV3TableField = ({ field, formGUID, decorators }) => {
   const [data, setData] = useState(null);
   const { formV3Data, changeFieldValue } = useFormV3();

   useEffect(() => {
      /* getFormWithData("66603405582f1f096d63c8b5").then((res) => {
         const columns = res.data?.fields;
         const rows = field?.value?.originalValue;
         setData(field?.value);
      }); */
      if (field?.value /* ?.originalValue */ && Array.isArray(field?.value /* ?.originalValue */)) {
         setData(field?.value /* ?.originalValue */);
      }
   }, []);

   return (
      <>
         <span className={`v3-field-element`}>
            {data ? (
               <TableDisplay preparedRows={data} itemsPerPage={100} showPager={false} />
            ) : (
               <Spin></Spin>
            )}
         </span>
      </>
   );
};

export default FormV3TableField;
